import { Pane, Heading, Text, HomeIcon, PeopleIcon, PathSearchIcon } from "evergreen-ui";
import HeroBanner from '../commons/HeroBanner';

const HomePage = () => {

  return (
    <Pane className="public-page-container home-container" background="tint1">
      {/* HERO SECTION */}
      <HeroBanner 
        title="Qui si riparte" 
        subtitle="Una casa che accoglie, ogni giorno"
        buttonText="Scopri chi siamo"
        buttonLink="/chi-siamo"
        bgImage="/hero_homepage (2).png" /* Sostituisci con il path reale */
        minHeight={400}
      />

      {/* SEZIONE IDENTITÀ */}
      <Pane maxWidth={1000} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
        <Text size={500} color="muted" marginBottom={40} display="block">Ogni storia merita spazio, tempo, cura.</Text>
        
        <Pane className="home-grid-3" display="grid" gap={24}>
          <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
            <div className="home-img-wrapper">
              <img src="/accogliamo_homepage.png" alt="Accogliamo" />
            </div>
            <Heading marginTop={16} size={600}>Accogliamo</Heading>
          </Pane>
          <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
            <div className="home-img-wrapper">
              <img src="/ascoltiamo_homepage (2).png" alt="Ascoltiamo" />
            </div>
            <Heading marginTop={16} size={600}>Ascoltiamo</Heading>
          </Pane>
          <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
            <div className="home-img-wrapper">
              <img src="/costruiamofuturo_homepage (2).png" alt="Costruiamo futuro" />
            </div>
            <Heading marginTop={16} size={600}>Costruiamo futuro</Heading>
          </Pane>
        </Pane>
      </Pane>

      {/* SEZIONE COSA FACCIAMO - RAPIDA */}
      <Pane background="tint2" paddingY={60}>
        <Pane maxWidth={1000} marginX="auto" paddingX={20} textAlign="center">
          <Heading size={700} marginBottom={40}>Cosa facciamo</Heading>
          <Pane className="home-grid-3" display="grid" gap={24}>
            <Pane className="home-grid-item flex-col-center" hoverElevation={3} cursor="pointer" padding={32} borderRadius={8} background="white" transition="all 0.2s">
              <HomeIcon size={40} color="muted" marginBottom={16} />
              <Heading size={500}>Accoglienza educativa</Heading>
            </Pane>
            <Pane className="home-grid-item flex-col-center" hoverElevation={3} cursor="pointer" padding={32} borderRadius={8} background="white" transition="all 0.2s">
              <PathSearchIcon size={40} color="muted" marginBottom={16} />
              <Heading size={500}>Percorsi personalizzati</Heading>
            </Pane>
            <Pane className="home-grid-item flex-col-center" hoverElevation={3} cursor="pointer" padding={32} borderRadius={8} background="white" transition="all 0.2s">
              <PeopleIcon size={40} color="muted" marginBottom={16} />
              <Heading size={500}>Lavoro con le famiglie</Heading>
            </Pane>
          </Pane>
        </Pane>
      </Pane>

      {/* SEZIONE CASA */}
      <Pane background="tint1">
        <Pane maxWidth={1000} marginX="auto" paddingY={60} paddingX={20} textAlign="center">
          <Heading size={700} marginBottom={40}>La casa</Heading>
          <Pane className="home-grid-3" display="grid" gap={24}>
            <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
              <div className="home-img-wrapper">
                <img src="/spazivissuti_homepage (2).png" alt="Spazi vissuti" />
              </div>
              <Heading marginTop={16} size={500}>Spazi vissuti</Heading>
            </Pane>
            <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
              <div className="home-img-wrapper">
                <img src="/routinequotidiana_homepage (2).png" alt="Routine quotidiana" />
              </div>
              <Heading marginTop={16} size={500}>Routine quotidiana</Heading>
            </Pane>
            <Pane className="home-grid-item" hoverElevation={3} cursor="pointer" padding={16} borderRadius={8} background="white" transition="all 0.2s">
              <div className="home-img-wrapper">
                <img src="/relazionivere_homepage (2).png" alt="Relazioni vere" />
              </div>
              <Heading marginTop={16} size={500}>Relazioni vere</Heading>
            </Pane>
          </Pane>
        </Pane>
      </Pane>

      {/* SEZIONE FINALE (METODO) */}
      <Pane background="#d4dfc9" paddingY={80} textAlign="center"> {/* Colore verde salvia */}
        <Heading size={700} marginBottom={40}>Il metodo</Heading>
        <Heading className="method-text" size={800} style={{ fontFamily: 'cursive' }}>
          Educare è esserci, ogni giorno.
        </Heading>
      </Pane>
    </Pane>
  );
};

export default HomePage;